// Star field fragment shader — a soft round core per point sprite.
//
// Colour is premultiplied by the falloff and alpha left at 1, which under
// AdditiveBlending (srcAlpha·src + dst) makes the sprite's contribution exactly
// its profile. Values run linear and unclamped into the HDR composer, so the
// brightest stars carry enough energy to trip the bloom threshold on their own.

#include <common>
#include <logdepthbuf_pars_fragment>

uniform float uCoreSharpness;

varying vec3 vColor;

void main() {
  #include <logdepthbuf_fragment>

  // A hard disc would crawl and alias badly at the 1–2 px sizes most of the
  // catalogue lands on, so the profile is a Gaussian that reaches ~0 by the
  // sprite edge and antialiases itself.
  vec2 d = gl_PointCoord - 0.5;
  float r2 = dot(d, d) * 4.0;              // 0 at centre → 1 at the sprite edge
  float a = exp(-r2 * uCoreSharpness);
  if (a < 0.004) discard;

  gl_FragColor = vec4(vColor * a, 1.0);
}
